module.exports = __webpack_public_path__ + "static/media/panorama.062fa537.jpg";